import gql from "graphql-tag"
import { MembershipFragmentDoc } from "@pathwright/graphql-client/src/generated"

export default gql`
  {
    me {
      id
      membership {
        ...Membership
      }
    }
  }
  ${MembershipFragmentDoc}
`
